import { Skeleton } from '@renderer/components/ui/skeleton'

export function ArtifactPreviewLoading() {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-24" />
    </div>
  )
}
